import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import { showNeoFrame, State } from '../shared/state-management/reducers';
import { WebserviceService } from '../xena/core/shared/services/webservice/webservice.service';
import { WebstartService } from '../shared/webstart/webstart.service';
import { WebstartList } from '../shared/webstart/models/webstart-response';
import * as AppStateActions from '../shared/state-management/actions/app-state';
import { WindowRef } from '../shared/services/window-ref';

@Component({
	selector: 'argus-frame',
	templateUrl: './argus-frame.component.html',
	styleUrls: ['./argus-frame.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArgusFrameComponent implements OnInit, AfterViewInit {
	public argusUrl$: Observable<SafeResourceUrl>;
	public showNeoFrame$: Observable<boolean> = this._store.select(showNeoFrame);
	public argusLoaded: boolean = false;

	private argusDisabled: boolean = false;

	@ViewChild('argusFrame') iframe: ElementRef;

	constructor(
		private _webservice: WebserviceService,
		private _store: Store<State>,
		private _sanitizer: DomSanitizer,
		private _webstart: WebstartService,
		private _windowRef: WindowRef,
		private _changeDetectorRef: ChangeDetectorRef
	) {}

	public ngOnInit(): void {
		this.argusUrl$ = this._webstart.getCachedWebstartByIdentifier('argus.go-suite')
			.map((argusWebstart: WebstartList) =>
				this._sanitizer.bypassSecurityTrustResourceUrl(argusWebstart[0].url)
			);
	}

	public ngAfterViewInit(): void {
		this._windowRef.nativeWindow.addEventListener('message', e => {
			if (e && e.data) {
				switch (e.data) {
					case 'argus-loaded':
						this.argusLoaded = true;
						this._changeDetectorRef.markForCheck();

						this.iframe.nativeElement.contentWindow.postMessage('enable-go-suite-style', '*');
						break;

					case 'argus-ready':
						this.iframe.nativeElement.contentWindow.postMessage('openDashboardMidoffice', '*');
						break;
				}
			}
		});
	}

	public closeNeoFrame(open: boolean) {
		if (!open) {
			this._store.dispatch(new AppStateActions.CloseNeoFrame());
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/argus-frame/argus-frame.component.ts